import type { BatteryTpoProductType } from "~/api/dto/battery-proposal.dto"

/**
 * Copy for TPO Finance Selection terms. A TPO offer has a product type, a
 * term and a yearly escalator; it never has an APR, dealer fee, or loan
 * amount, so nothing here formats one.
 */

export const TPO_PRODUCT_TYPE_LABEL: Record<BatteryTpoProductType, string> = {
  lease: `Lease`,
  ppa: `PPA`,
}

const escalatorPercent = new Intl.NumberFormat(`en-US`, {
  style: `percent`,
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

/** The provider's escalator as sent (0.0099), shown as a percentage (0.99%). */
export const formatEscalator = (escalationRate: number): string =>
  escalatorPercent.format(escalationRate)

/** "10-year term · 0.99% annual escalator" */
export const tpoTermsText = (terms: {
  termYears: number
  escalationRate: number
}): string =>
  `${terms.termYears}-year term · ${formatEscalator(terms.escalationRate)} annual escalator`
